module.exports = __webpack_public_path__ + "static/media/mode4.4d5b1cb3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode4.gif
// module id = 1349
// module chunks = 110